import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Avatar from "@material-ui/core/Avatar";

import Error from "next/error";
import Head from 'next/head';
import router from "next/router";

import Link from "../../src/Link";
import { db } from "../../src/utils/firebase";
import withAuth from "../../src/utils/withAuth";
import UploadFormNoSSR from "../../src/UploadFormNoSSR";
import { getFollowers, getFollowing } from "../../src/utils/user";
import {
  followUser,
  unfollowUser,
  isFollowingUser,
} from "../../src/utils/firebase";
import { linkify } from '../../src/utils/linkify';

import Layout from "../../src/Layout";
import VideoFeed from "../../src/VideoFeed";

const useStyles = makeStyles((theme) => ({
  videoWrapper: {
    marginTop: 20,
    marginBottom: 20,
    [theme.breakpoints.up('md')]: {
      marginTop: 60,
      marginBottom: 60,
    }
  },
  avatar: {
    width: 80,
    height: 80,
    float: 'left',
    marginRight: 10,
    marginBottom: 10,
    [theme.breakpoints.up('sm')]: {
      width: 100,
      height: 100,
    }
  },
  hero: {
    background: 'url(/bg-hero-profile.webp)',
    backgroundSize: 'cover',
    paddingTop: 40,
    paddingBottom: 60,
    color: "#fff"
  },
  metaWrapper: {
    borderLeft: '1px solid rgba(255,255,255,0.3)'
  },
  meta: {
    "& dt": {
      fontSize: 20
    },
    "& dd": {
      fontSize: 12,
      marginLeft: 0,
      marginBottom: 10
    }
  }
}));

function Profile(props) {
  const classes = useStyles();

  const { user } = props;

  if (!user) {
    return <Error statusCode={404} />;
  }

  let followers = getFollowers(user.email);
  let following = getFollowing(user.email);

  const [followingUser, setFollowingUser] = useState(null);

  useEffect(() => {
    if (props.auth.authenticated && props.auth.user) {
      isFollowingUser(props.auth.user.email, user.email).then((res) => {
        return setFollowingUser(res)
      });
    }
  }, []);

  function toggleFollow() {
    setFollowingUser(!followingUser);
  }

  return (
    <Layout>
      <Head>
        <title>{user.username} - Better than Vegas</title>
      </Head>
      <div className={classes.hero}>
        <Container maxWidth="sm">
          <Grid container spacing={3}>
            <Grid item xs={9} sm={8}>
              <Avatar
                src={user.photoURL}
                className={classes.avatar} />
              <div style={{marginBottom: 40}}>
                <Typography
                  variant="h5"
                  color="inherit"
                >
                  {`${user.firstName} ${user.lastName}`}
                </Typography>

                <Typography
                  variant="h6"
                  color="inherit"
                  paragraph
                >
                  {user.username}
                </Typography>


                {props.auth.authenticated && user.email == props.auth.user.email && (
                  <UploadFormNoSSR label="Upload Video" />
                )}

                {props.auth.authenticated &&
                 user.email != props.auth.user.email &&
                 followingUser && (
                   <Button
                     size="small"
                     variant="contained"
                     color="secondary"
                     onClick={() => {
                       unfollowUser(props.auth.user.email, user.email);
                       toggleFollow();
                     }}
                   >
                     Unsubscribe
                   </Button>
                 )}

                {(!props.auth.authenticated ||
                  (user.email != props.auth.user.email && !followingUser)) && (
                   <Button
                     size="small"
                     variant="contained"
                     color="secondary"
                     onClick={() => {
                       if (props.auth.authenticated) {
                         followUser(props.auth.user.email, user.email);
                         toggleFollow();
                       }
                       else {
                         router.push({
                           pathname: '/register',
                           query: { subscribe: user.username }
                         });
                       }
                     }}
                   >
                     Subscribe
                   </Button>
                 )}
              </div>

              { user.bio && user.bio.length > 0 && (
                <Typography
                  variant="body2"
                  color="inherit"
                  style={{whiteSpace: "pre-line"}}
                  paragraph
                >
                  {linkify(user.bio, "white")}
                </Typography>
              )}
            </Grid>
            <Grid item xs={3} sm={4} className={classes.metaWrapper}>
              <dl className={classes.meta}>
                <dt>
                  <Link color="inherit" href={`/profile/${user.username}/followers`}>
                    {followers && followers.data ? followers.data.length : 0}
                  </Link>
                </dt>
                <dd>Subscribers</dd>
                <dt>
                  <Link color="inherit" href={`/profile/${user.username}/following`}>
                    {following && following.data ? following.data.length : 0}
                  </Link>
                </dt>
                <dd>Following</dd>
                <dt>0</dt>
                <dd>Videos</dd>
                <dt>0</dt>
                <dd>Views</dd>
              </dl>
            </Grid>
          </Grid>
        </Container>
      </div>
      <Container maxWidth="lg">
        <div className={classes.videoWrapper}>
          <VideoFeed user={user.email} title="Recent Videos" />
        </div>
        {/* </main> */}
      </Container>
    </Layout>
  );
}

export async function getServerSideProps(context) {
  const result = await db
        .collection("users")
        .where("username", "==", context.params.user)
        .limit(1)
        .get()

  let user = null;

  if (!result.empty) {
    user = {
      email: result.docs[0].get("email") || "",
      firstName: result.docs[0].get("firstName") || "",
      lastName: result.docs[0].get("lastName") || "",
      username: result.docs[0].get("username") || "",
      bio: result.docs[0].get("bio") || "",
      photoURL: result.docs[0].get("photoURL") || "/avatar-white.png"
    };
  }

  return {
    props: { user: user },
  };
}

export default withAuth(Profile);
